module.exports = __webpack_public_path__ + "9a62c3d1f3ca4b470bc4a446f5c9c9e1.mp3";


//////////////////
// WEBPACK FOOTER
// ./sounds/tweet.mp3
// module id = 14
// module chunks = 0